// extracted by mini-css-extract-plugin
module.exports = {"amounts":"Amounts_amounts__vlTrR","divider":"Amounts_divider__3_vd6"};